// frontend/src/utils/sanitizeContent.js
import DOMPurify from 'dompurify';

export const highlightMentions = (text = "") => {
    if (!text) return "";

    let safeText = text
        .replace(/&/g, "&amp;") // Escape & first to avoid double escaping
        .replace(/</g, "&lt;") // Escape < and > to prevent HTML injection
        .replace(/>/g, "&gt;") // Escape < and > to prevent HTML injection
        .replace(/"/g, "&quot;") // Escape " to prevent attribute injection
        .replace(/'/g, "&#039;"); // Escape ' to prevent attribute injection

    const mentionRegex = /@([A-Za-z0-9_]+(?:\s[0-9]+)?)/g; // Matches @username or @username 123
    const withMentions = safeText.replace(
        mentionRegex,
        '<span style="color:#1976d2; font-weight:600;">@$1</span>'
    ); // Wrap mentions in a span with styling

    const withBreaks = withMentions.replace(/\n/g, "<br/>"); // Replace newlines with <br/> for line breaks

    return DOMPurify.sanitize(withBreaks, {
        ALLOWED_TAGS: ['span', 'br'], // Allow only span and br tags for mentions and line breaks
        ALLOWED_ATTR: ['style'], // Allow only the style attribute for span tags
    });
};